import { useAppSelector } from 'careand-redux/store';
import React, { useMemo } from 'react';
import AppointmentUtils from 'services/AppointmentUtils';
import useFetchPatients from 'hooks/useFetchPatients';
import DragAndDropCalendar from 'components/Schedule/DragAndDropCalendar';
import PhysicianCalendar from 'components/Schedule/PhysicianCalendar';
import SlotTimeTooltip from 'components/Schedule/SlotTimeTooltip';
import ScheduleDragPreview from 'components/Schedule/ScheduleDragPreview';
import { Device } from 'services/Native/Device';
import { useMediaQuery } from '@material-ui/core';

const DEFAULT_ARRAY = [];

const PhysicianCalendars = ({
  physicians = DEFAULT_ARRAY,
  shifts = DEFAULT_ARRAY,
  moveEvent,
  onEventClick,
  date,
  showCancelled,
  showActualTime,
  onSelectSlot,
  disableDragNDrop,
  clinicId,
}) => {
  const isPhone = useMediaQuery('(max-width: 767px)');

  const selectorAppointments = useAppSelector((state) => state.appointments.byId);

  const appointments = useMemo(() => {
    return AppointmentUtils.getScheduleAppointments(
      selectorAppointments,
      physicians,
      date,
      showCancelled,
    );
  }, [selectorAppointments, physicians, date, showCancelled]);

  useFetchPatients(appointments);

  const shiftsByPhysician = useMemo(() => {
    let result = {};
    physicians.forEach((physician) => {
      result[physician.id] = shifts.find(
        (shift) => shift.user_id === physician.id && shift.clinic_id === clinicId,
      );
    });
    return result;
  }, [physicians, shifts, clinicId]);

  const telemedicineByPhysician = useMemo(() => {
    let result = {};
    physicians.forEach((physician) => {
      result[physician.id] = shifts.some(
        (shift) =>
          shift.user_id === physician.id &&
          shift.clinic_id === clinicId &&
          !!shift.telemedicine_only,
      );
    });
    return result;
  }, [physicians, shifts, clinicId]);

  return (
    <SlotTimeTooltip className="physician-calendars">
      <ul>
        <div className="ul-content">
          <li className="schedule hour-only">
            <DragAndDropCalendar className="hour-calendar" draggable={false} />
          </li>
          {physicians.map((physician) => {
            let shift = shiftsByPhysician[physician.id];
            return (
              <PhysicianCalendar
                key={physician.id || 'unassigned'}
                physician={physician}
                date={date}
                moveEvent={
                  moveEvent
                    ? (payload) => {
                        moveEvent(physician.id, payload);
                      }
                    : undefined
                }
                onEventClick={onEventClick}
                shift={shift}
                telemedicineOnly={telemedicineByPhysician[physician.id]}
                showCancelled={showCancelled}
                showActualTime={showActualTime}
                onSelectSlot={(slot) => onSelectSlot(physician, slot)}
                disableDragNDrop={disableDragNDrop || isPhone}
                clinicId={clinicId}
                slotTimeTooltip={!isPhone}
              />
            );
          })}
        </div>
      </ul>
      <ScheduleDragPreview />
    </SlotTimeTooltip>
  );
};

export default PhysicianCalendars;
